// ============================================
// DojoMaster - Martial Arts Studio Management
// Wireframe Preview App
// ============================================
import React, { useState } from 'react';

// Import wireframe modules
import DojoMobileWireframes from './DojoMobileWireframes';
import DojoAdminWireframes from './DojoAdminWireframes';
import DojoMasterPresentation from './DojoMasterPresentation';

const MODES = [
  { id: 'presentation', label: '📋 Client Presentation', description: 'Scrollable user-flow document — all screens in context, ready for client review' },
  { id: 'mobile', label: '📱 Mobile App (Coach + Student)', description: 'Flutter mobile wireframes — Coach live attendance, Student QR scan at reception, Parent multi-child' },
  { id: 'admin', label: '🖥️ Admin Portal', description: 'React web/tablet portal wireframes — Dashboard, Session Kiosk, QR/Biometric attendance, Finance, WhatsApp' },
];

export default function DojoApp() {
  const [mode, setMode] = useState('presentation');

  return (
    <div style={{ minHeight: '100vh', background: '#0F0F1A', fontFamily: "'Inter', sans-serif" }}>
      {/* Mode Selector Bar */}
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'linear-gradient(135deg, #2D3748, #1A202C)',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}>
        <div style={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          fontSize: 18,
          color: '#fff',
          marginRight: 16,
          whiteSpace: 'nowrap',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}>
          <span style={{ fontSize: 22 }}>🥋</span>
          <span>Dojo<span style={{ color: '#C41E3A' }}>Master</span></span>
        </div>

        <div style={{ width: 1, height: 24, background: 'rgba(255,255,255,0.12)', flexShrink: 0 }} />

        {MODES.map(m => (
          <button
            key={m.id}
            onClick={() => setMode(m.id)}
            style={{
              padding: '8px 20px',
              borderRadius: 20,
              border: 'none',
              fontFamily: "'Inter', sans-serif",
              fontSize: 13,
              fontWeight: mode === m.id ? 600 : 400,
              cursor: 'pointer',
              transition: '0.3s',
              background: mode === m.id ? '#C41E3A' : 'rgba(255,255,255,0.08)',
              color: mode === m.id ? '#fff' : 'rgba(255,255,255,0.6)',
              whiteSpace: 'nowrap',
            }}
          >
            {m.label}
          </button>
        ))}

        <div style={{ marginLeft: 'auto', fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>
          {MODES.find(m => m.id === mode)?.description}
        </div>
      </div>

      {/* Content */}
      {mode === 'presentation' && <DojoMasterPresentation />}
      {mode === 'mobile' && <DojoMobileWireframes />}
      {mode === 'admin' && <DojoAdminWireframes />}
    </div>
  );
}
